<template>
  <div>
    <div
      v-if="withFilter"
      data-testid="main-error-filter"
      class="main-error__filter"
    />
    <div class="main-error__container">
      <Heading class="main-error__title" :level="4">
        {{ title }}
      </Heading>
      <BaseText v-if="description" class="main-error__description" size="sm">
        {{ description }}
      </BaseText>
      <ButtonSecondary
        label="Tentar novamente"
        icon="ic_redo"
        icon-position="right"
        @click="emitOnRetry"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { BaseText, ButtonSecondary, Heading } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    BaseText,
    ButtonSecondary,
    Heading
  }
})
export default class ChartError extends Vue {
  @Prop({ type: String, required: false })
  readonly description?: string;

  @Prop({ type: Boolean, default: true })
  readonly withFilter!: boolean;

  @Prop({ type: String, required: true })
  readonly title!: string;

  @Emit('on-retry')
  emitOnRetry() {}
}
</script>
<style lang="less" scoped>
.main-error {
  &__container {
    height: 312px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: @background-primary;
    border-radius: @size-radius-x200;
    margin-top: @size-spacing-x300;
  }

  &__title {
    margin-bottom: @size-spacing-x150;
  }

  &__description {
    margin-bottom: @size-spacing-x500;
  }

  &__filter {
    margin-top: @size-spacing-x800;
    width: 100px;
    height: 40px;
    border-radius: @size-radius-x400;
    background-color: @background-primary;
  }
}
</style>
